/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { GuidItemGroupDto } from './GuidItemGroupDto';
import {
    GuidItemGroupDtoFromJSON,
    GuidItemGroupDtoFromJSONTyped,
    GuidItemGroupDtoToJSON,
} from './GuidItemGroupDto';
import type { InstructionDto } from './InstructionDto';
import {
    InstructionDtoFromJSON,
    InstructionDtoFromJSONTyped,
    InstructionDtoToJSON,
} from './InstructionDto';
import type { ReferredEntityChange } from './ReferredEntityChange';
import {
    ReferredEntityChangeFromJSON,
    ReferredEntityChangeFromJSONTyped,
    ReferredEntityChangeToJSON,
} from './ReferredEntityChange';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';
import type { WorkStepPreviewDto } from './WorkStepPreviewDto';
import {
    WorkStepPreviewDtoFromJSON,
    WorkStepPreviewDtoFromJSONTyped,
    WorkStepPreviewDtoToJSON,
} from './WorkStepPreviewDto';

/**
 * 
 * @export
 * @interface TaskInJobDto
 */
export interface TaskInJobDto {
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskInJobDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskInJobDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    taskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    taskAreaId?: string;
    /**
     * 
     * @type {Array<GuidItemGroupDto>}
     * @memberof TaskInJobDto
     */
    supportSystemIds?: Array<GuidItemGroupDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof TaskInJobDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    description?: string | null;
    /**
     * 
     * @type {InstructionDto}
     * @memberof TaskInJobDto
     */
    instruction?: InstructionDto;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    readonly taskInJobId?: string;
    /**
     * 
     * @type {ReferredEntityChange}
     * @memberof TaskInJobDto
     */
    taskChange?: ReferredEntityChange;
    /**
     * 
     * @type {ReferredEntityChange}
     * @memberof TaskInJobDto
     */
    taskAreaChange?: ReferredEntityChange;
    /**
     * 
     * @type {number}
     * @memberof TaskInJobDto
     */
    index?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInJobDto
     */
    disabled?: boolean;
    /**
     * 
     * @type {StateOfUse}
     * @memberof TaskInJobDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {Array<WorkStepPreviewDto>}
     * @memberof TaskInJobDto
     */
    workSteps?: Array<WorkStepPreviewDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    $type?: TaskInJobDtoTypeEnum;
}


/**
 * @export
 */
export const TaskInJobDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoTaskInJobDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.TaskInJobDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskInJobDtoTypeEnum = typeof TaskInJobDtoTypeEnum[keyof typeof TaskInJobDtoTypeEnum];


/**
 * Check if a given object implements the TaskInJobDto interface.
 */
export function instanceOfTaskInJobDto(value?: unknown): value is TaskInJobDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskInJobDtoTypeEnum)[0];
}

export function TaskInJobDtoFromJSON(json: any): TaskInJobDto {
    return TaskInJobDtoFromJSONTyped(json, false);
}

export function TaskInJobDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskInJobDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'taskId': !exists(json, 'taskId') ? undefined : json['taskId'],
        'taskAreaId': !exists(json, 'taskAreaId') ? undefined : json['taskAreaId'],
        'supportSystemIds': !exists(json, 'supportSystemIds') ? undefined : (json['supportSystemIds'] === null ? null : (json['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoFromJSON)),
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'instruction': !exists(json, 'instruction') ? undefined : InstructionDtoFromJSON(json['instruction']),
        'taskInJobId': !exists(json, 'taskInJobId') ? undefined : json['taskInJobId'],
        'taskChange': !exists(json, 'taskChange') ? undefined : ReferredEntityChangeFromJSON(json['taskChange']),
        'taskAreaChange': !exists(json, 'taskAreaChange') ? undefined : ReferredEntityChangeFromJSON(json['taskAreaChange']),
        'index': !exists(json, 'index') ? undefined : json['index'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'workSteps': !exists(json, 'workSteps') ? undefined : (json['workSteps'] === null ? null : (json['workSteps'] as Array<any>).map(WorkStepPreviewDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TaskInJobDtoToJSON(value?: TaskInJobDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'name': value.name,
        'taskId': value.taskId,
        'taskAreaId': value.taskAreaId,
        'supportSystemIds': value.supportSystemIds === undefined ? undefined : (value.supportSystemIds === null ? null : (value.supportSystemIds as Array<any>).map(GuidItemGroupDtoToJSON)),
        'iuid': value.iuid,
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'description': value.description,
        'instruction': InstructionDtoToJSON(value.instruction),
        'taskChange': ReferredEntityChangeToJSON(value.taskChange),
        'taskAreaChange': ReferredEntityChangeToJSON(value.taskAreaChange),
        'index': value.index,
        'disabled': value.disabled,
        'state': StateOfUseToJSON(value.state),
        'workSteps': value.workSteps === undefined ? undefined : (value.workSteps === null ? null : (value.workSteps as Array<any>).map(WorkStepPreviewDtoToJSON)),
        '$type': value.$type,
    });
}

